import { UseCaseGroup, UseCaseVddList } from '@vi-iot/client';
import { UseCaseTypesEnum } from '../../../projects/client/apis/remote-diagnostics/remote-diagnostics.model';

import { ServiceLayerVddListName } from '../remote-diagnostics/remote-diagnostics.model';

export enum ExtendedParametersTabsEnum {
  SearchedParameters = 'SearchedParameters',
  UseCases = 'UseCases',
}

export const serviceLayerGroups: UseCaseGroup[] = [
  {
    texttableentry: ServiceLayerVddListName.SystemConfigurationGeneral,
    interval: '',
    TI_texttableentry: '+REMOTE_DIAGNOSTICS.VDD_PICKER_LIST.SYSTEM_CONFIGURATION_GENERAL',
  },
  {
    texttableentry: ServiceLayerVddListName.SystemConfigurationBoiler,
    interval: '',
    TI_texttableentry: '+REMOTE_DIAGNOSTICS.VDD_PICKER_LIST.SYSTEM_CONFIGURATION_BOILER',
  },
  {
    texttableentry: ServiceLayerVddListName.SystemConfigurationDHW,
    interval: '',
    TI_texttableentry: '+REMOTE_DIAGNOSTICS.VDD_PICKER_LIST.SYSTEM_CONFIGURATION_DHW',
  },
  {
    texttableentry: ServiceLayerVddListName.SystemConfigurationHeatingCircuits,
    interval: '',
    TI_texttableentry: '+REMOTE_DIAGNOSTICS.VDD_PICKER_LIST.SYSTEM_CONFIGURATION_HEATING_CIRCUITS',
  },
  {
    texttableentry: ServiceLayerVddListName.DiagnoseGeneral,
    interval: '',
    TI_texttableentry: '+REMOTE_DIAGNOSTICS.VDD_PICKER_LIST.DIAGNOSE_GENERAL',
  },
  {
    texttableentry: ServiceLayerVddListName.DiagnoseDHW,
    interval: '',
    TI_texttableentry: '+REMOTE_DIAGNOSTICS.VDD_PICKER_LIST.DIAGNOSE_DHW',
  },
  {
    texttableentry: ServiceLayerVddListName.DiagnoseHeatingCircuit,
    interval: '',
    TI_texttableentry: '+REMOTE_DIAGNOSTICS.VDD_PICKER_LIST.DIAGNOSE_HEATING_CIRCUIT',
  },
];

export const serviceLayerVddGroups: UseCaseVddList[] = [
  {
    usecaseName: ServiceLayerVddListName.SystemConfigurationGeneral,
    usecaseType: UseCaseTypesEnum.ServiceLayer,
    structure: [
      {
        vdd: 'ExternalTargetFlowTemperatureSetpoint',
      },
      {
        vdd: 'OutsideTemperatureOffset',
      },
      {
        vdd: 'GasProperties', // gasVolumCorreFactoHighResol and calorValueHighResol
      },
    ],
  },
  {
    usecaseName: ServiceLayerVddListName.SystemConfigurationBoiler,
    usecaseType: UseCaseTypesEnum.ServiceLayer,
    structure: [
      {
        vdd: 'DomesticHotWaterPartLoadPercent',
      },
      {
        vdd: 'CentralHeatingPumpMinimumMaximumLimit',
      },
      {
        vdd: 'ResetServiceInterval',
      },
      {
        vdd: 'MinimumLoadPercent',
      },
      {
        vdd: 'IntervalStrategyProperties',
      },
    ],
  },
  {
    usecaseName: ServiceLayerVddListName.SystemConfigurationDHW,
    usecaseType: UseCaseTypesEnum.ServiceLayer,
    structure: [
      {
        vdd: 'ScaldProtection',
      },
      {
        vdd: 'DomesticHotWaterPumpPostRunTime',
      },
      {
        vdd: 'MaximumDomesticHotWaterLoadingTime',
      },
      {
        vdd: 'DomesticHotWaterCirculationPumpMode',
      },
    ],
  },
  {
    usecaseName: ServiceLayerVddListName.SystemConfigurationHeatingCircuits,
    usecaseType: UseCaseTypesEnum.ServiceLayer,
    structure: [
      {
        vdd: 'MixerOneCircuitProperty',
      },
      {
        vdd: 'MixerOneCircuitPumpMinimumMaximumLimit',
      },
      {
        vdd: 'MixerOneCircuitFlowTemperatureMinimumMaximumLimit',
      },
    ],
  },
  {
    usecaseName: ServiceLayerVddListName.DiagnoseGeneral,
    usecaseType: UseCaseTypesEnum.ServiceLayer,
    structure: [
      {
        vdd: 'PrimaryCircuitCurrentTemperatureSetpoint',
      },
      {
        vdd: 'HydraulicSeparatorTemperatureSensor',
      },
      {
        vdd: 'HydraulicSeparatorReturnTemperatureSensor',
      },
      {
        vdd: 'CentralHeatingPump',
      },
      {
        vdd: 'FlueGasTemperatureSensor',
      },
      {
        vdd: 'ThermalPower',
      },
      {
        vdd: 'MalfunctionIdentification',
      },
      {
        vdd: 'DiverterValveTargetPosition',
      },
    ],
  },
  {
    usecaseName: ServiceLayerVddListName.DiagnoseDHW,
    usecaseType: UseCaseTypesEnum.ServiceLayer,
    structure: [
      {
        vdd: 'DomesticHotWaterCirculationTimeScheduleMonday',
      },
      {
        vdd: 'DomesticHotWaterCirculationTimeScheduleTuesday',
      },
      {
        vdd: 'DomesticHotWaterCirculationTimeScheduleWednesday',
      },
      {
        vdd: 'DomesticHotWaterCirculationTimeScheduleThursday',
      },
      {
        vdd: 'DomesticHotWaterCirculationTimeScheduleFriday',
      },
      {
        vdd: 'DomesticHotWaterCirculationTimeScheduleSaturday',
      },
      {
        vdd: 'DomesticHotWaterCirculationTimeScheduleSunday',
      },
      {
        vdd: 'BufferTopTemperatureSensor',
      },
      {
        vdd: 'BufferMidTopTemperatureSensor',
      },
      {
        vdd: 'DomesticHotWaterTemperatureSetpoint',
      },
      {
        vdd: 'DomesticHotWaterSensor',
      },
      {
        vdd: 'DomesticHotWaterCirculationPump',
      },
      {
        vdd: 'DomesticHotWaterPump',
      },
    ],
  },
  {
    usecaseName: ServiceLayerVddListName.DiagnoseHeatingCircuit,
    usecaseType: UseCaseTypesEnum.ServiceLayer,
    structure: [
      {
        vdd: 'AccessoryMixerOneOperationMode',
      },
      {
        vdd: 'MixerOneCircuitOperationState',
      },
      {
        vdd: 'MixerOneCircuitTimeScheduleMonday',
      },
      {
        vdd: 'MixerOneCircuitRoomTemperatureSetpoint',
      },
      {
        vdd: 'MixerOneCircuitRoomTemperatureSensor',
      },
      {
        vdd: 'MixerOneCircuitRoomTemperatureSetpoint',
      },
      {
        vdd: 'MixerTwoCircuitRoomTemperatureSetpoint',
      },
      {
        vdd: 'MixerThreeCircuitRoomTemperatureSetpoint',
      },
      {
        vdd: 'MixerFourCircuitRoomTemperatureSetpoint',
      },
      {
        vdd: 'MixerOneCircuitCentralHeatingCurve',
      },
      {
        vdd: 'MixerOneCircuitFlowTemperatureTargetSetpoint',
      },
      {
        vdd: 'MixerTwoCircuitFlowTemperatureTargetSetpoint',
      },
      {
        vdd: 'MixerThreeCircuitFlowTemperatureTargetSetpoint',
      },
      {
        vdd: 'MixerFourCircuitFlowTemperatureTargetSetpoint',
      },
      {
        vdd: 'MixerFiveCircuitFlowTemperatureTargetSetpoint',
      },
      {
        vdd: 'MixerSixCircuitFlowTemperatureTargetSetpoint',
      },
      {
        vdd: 'MixerSevenCircuitFlowTemperatureTargetSetpoint',
      },
      {
        vdd: 'MixerEightCircuitFlowTemperatureTargetSetpoint',
      },
      {
        vdd: 'MixerNineCircuitFlowTemperatureTargetSetpoint',
      },
      {
        vdd: 'MixerTenCircuitFlowTemperatureTargetSetpoint',
      },
      {
        vdd: 'MixerElevenCircuitFlowTemperatureTargetSetpoint',
      },
      {
        vdd: 'MixerTwelveCircuitFlowTemperatureTargetSetpoint',
      },
      {
        vdd: 'MixerThirteenCircuitFlowTemperatureTargetSetpoint',
      },
      {
        vdd: 'MixerFourteenCircuitFlowTemperatureTargetSetpoint',
      },
      {
        vdd: 'MixerFifteenCircuitFlowTemperatureTargetSetpoint',
      },
      {
        vdd: 'MixerSixteenCircuitFlowTemperatureTargetSetpoint',
      },
      {
        vdd: 'MixerOneCircuitFlowTemperatureSensor',
      },
      {
        vdd: 'MixerTwoCircuitFlowTemperatureSensor',
      },
      {
        vdd: 'MixerThreeCircuitFlowTemperatureSensor',
      },
      {
        vdd: 'MixerFourCircuitFlowTemperatureSensor',
      },
      {
        vdd: 'MixerFiveCircuitFlowTemperatureSensor',
      },
      {
        vdd: 'MixerSixCircuitFlowTemperatureSensor',
      },
      {
        vdd: 'MixerSevenCircuitFlowTemperatureSensor',
      },
      {
        vdd: 'MixerEightCircuitFlowTemperatureSensor',
      },
      {
        vdd: 'MixerNineCircuitFlowTemperatureSensor',
      },
      {
        vdd: 'MixerTenCircuitFlowTemperatureSensor',
      },
      {
        vdd: 'MixerElevenCircuitFlowTemperatureSensor',
      },
      {
        vdd: 'MixerTwelveCircuitFlowTemperatureSensor',
      },
      {
        vdd: 'MixerThirteenCircuitFlowTemperatureSensor',
      },
      {
        vdd: 'MixerFourteenCircuitFlowTemperatureSensor',
      },
      {
        vdd: 'MixerFifteenCircuitFlowTemperatureSensor',
      },
      {
        vdd: 'MixerSixteenCircuitFlowTemperatureSensor',
      },
      {
        vdd: 'MixerOneCircuitPump',
      },
      {
        vdd: 'MixerOneCircuitFlowTemperatureTargetSetpoint',
      },
      {
        vdd: 'MixerOneCircuitFlowTemperatureSensor',
      },
      {
        vdd: 'HolidayPhaseCircuitOne',
      },
      {
        vdd: 'HolidayPhaseCircuitTwo',
      },
      {
        vdd: 'HolidayPhaseCircuitThree',
      },
      {
        vdd: 'HolidayPhaseCircuitFour',
      },
      {
        vdd: 'HolidayAtHomePhaseCircuitOne',
      },
      {
        vdd: 'HolidayAtHomePhaseCircuitTwo',
      },
      {
        vdd: 'HolidayAtHomePhaseCircuitThree',
      },
      {
        vdd: 'HolidayAtHomePhaseCircuitFour',
      },
    ],
  },
];
